import { useQuery } from "@tanstack/react-query";
import { WeeklySnapshotDTO } from "@intentsify/dto";
import { useState } from "react";
import { getCoverageByRevenueSize } from "./CoverageByRevenueSize.requests";
import { Card, MIN_MODAL_CONTENT_HEIGHT, PieChart } from "components";
import { ChartExport, useExportableChart } from "shared/components";

type CoverageByRevenueSizeProps = {
  campaignId: number;
  filters: WeeklySnapshotDTO;
};

const CoverageByRevenueSize = ({
  campaignId,
  filters,
}: CoverageByRevenueSizeProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { data, isFetching } = useQuery(
    ["getCoverageByRevenueSize", campaignId, filters],
    () => getCoverageByRevenueSize(campaignId, filters)
  );

  const chart = useExportableChart({
    title: "Active Account Coverage By Revenue Size",
    campaignId,
    chart: (
      <PieChart
        minHeight={isExpanded ? MIN_MODAL_CONTENT_HEIGHT : undefined}
        stretch
        fixedRatio={[1, 1]}
        legendPosition="bottom"
        data={data ?? []}
        shouldSort={false}
        displayAsPercent={true}
      />
    ),
  });

  return (
    <Card
      onExpandedChange={setIsExpanded}
      isLoading={isFetching}
      title={chart.title}
      hasData={!isFetching && Boolean(data?.length)}
      isExpandable
      actions={
        <ChartExport
          size="small"
          campaignId={campaignId}
          title={chart.title}
          onExportPNG={chart.downloadAsPng}
          data={data}
        />
      }
    >
      {chart.component}
      {chart.exportComponent}
    </Card>
  );
};

export { CoverageByRevenueSize };
